// extracted by mini-css-extract-plugin
export default {"ask-why-tab":"AskWhyTabV2_ask-why-tab__5Y1a8","ask-why-tab-panelists":"AskWhyTabV2_ask-why-tab-panelists__tyODf","tabs":"AskWhyTabV2_tabs__tkRGZ"};